
import { defineComponent, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'

// > components <
import { BsHeader, BsAccount, BsInvoiceSearch } from '@/modern/components'
import Sidebar from '@/common/components/Sidebar/index.vue'

// > legacy/composable/useAuth <
import useAuth from '@/common/composable/useAuth'
// > legacy/composable/useAccount <
import useAccount from '@/common/composable/useAccount'
// > legacy/store/globalStore
import { useGlobalStore } from '@/store/globalStore'

export default defineComponent({
    components: {
        Sidebar,
        BsHeader,
        BsAccount,
        BsInvoiceSearch
    },
    setup() {
        const store = useGlobalStore()
        const router = useRouter()

        const account = useAccount()
        const { removeAuthorization } = useAuth()

        const onLogout = () => {
            const answer = confirm(`Вы уверены что хотите выйти из учетной записи?`)
            if (!answer) return

            removeAuthorization()
            account.reset()

            router.replace({ name: 'Auth' })
        }

        onMounted(() => {
            const html = document.documentElement
            const theme = localStorage.getItem('spark-bpms-m-theme')
            
            if (theme && theme === 'dark') {
                html.setAttribute('data-theme', 'dark')
            } else {
                html.setAttribute('data-theme', 'light')
            }
        })

        onBeforeUnmount(() => {
            const html = document.documentElement
            html.removeAttribute('data-theme')
        })
        
        const username = computed(() => {
            if (account.state.user_name && account.state.user_name !== '') {
                return account.state.user_name
            }

            return 'Неизвестный пользователь'
        })

        const role = computed(() => {
            if (account.state.is_loading || account.state.is_failed) {
                return null
            }

            if (account.state.roles.length > 0) {
                return account.state.roles[0].name
            }

            return null
        })

        return {
            store,
            onLogout,
            username,
            role,
        }
    }
})
